import React from 'react';

const Cart = ({ products, cart, total, checkout, cartShown, hideCart }) => {
	return (
		<div className={`${cartShown}Overlay`} onClick={hideCart}>
			<div className={`${cartShown}Cart cart`}>
				<button className='close' onClick={hideCart}>
					X
				</button>
				<h2>Shopping Cart</h2>
				<ul className='cartItems'>
					<li className='cartItem'>
						<span>Item Name</span>
						<span>Quantity</span>
					</li>
					{products.map(item => {
						//only show items with at least 1 in cart
						if (cart[item.id] !== 0) {
							return (
								<li className='cartItem' key={item.id}>
									<span className='itemName'>{item.name} </span>
									<span className='quantity'>{cart[item.id]}</span>
								</li>
							);
						}
					})}
				</ul>
				<p className='total'>Total: ${total}</p>
				<button onClick={checkout} className='checkout'>
					check out
				</button>
			</div>
		</div>
	);
};

export default Cart;
